import React, { useState, useEffect, useRef } from 'react';
import styles from './MultivariateAnalysis.module.css';
import ScatterChart from './Charts/ScatterChart';
import Heatmap from './Charts/Heatmap';
import LineChart from './Charts/LineChart';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../../hook/use-http';
import { useMultivarientVehicleData } from './context';
import ChartLoader from '../../../Shared/Loader';

const xAxisValues = [
  { name: "Select X Parameter", value: "" },
  { name: "percentageTimeSpentInAcc_pedal_position_1_0_10_20", value: "percentagetimespentinacc_pedal_position_1_0_10_20" },
  { name: "percentageTimeSpentInAcc_pedal_position_1_20_30_40", value: "percentagetimespentinacc_pedal_position_1_20_30_40" },
  { name: "percentageTimeSpentInAcc_pedal_position_1_40_50_60", value: "percentagetimespentinacc_pedal_position_1_40_50_60" },
  { name: "percentageTimeSpentInAcc_pedal_position_1_60_70_80", value: "percentagetimespentinacc_pedal_position_1_60_70_80" },
  { name: "percentageTimeSpentInAcc_pedal_position_1_80_90_100", value: "percentagetimespentinacc_pedal_position_1_80_90_100" },
  { name: "timeSpentInRegenderating_0_1_2", value: "timespentinregenderating_0_1_2" },
  { name: "timeSpentInRegenderating_3_4", value: "timespentinregenderating_3_4" },
  { name: "timeSpentInRegenderating_5_6_6+", value: "timespentinregenderating_5_6_6plus" },
  { name: "tractionTorqueAvailable", value: "tractiontorqueavailable" },
  { name: "BCS1_State, BCS2_State", value: "bcs1_state_bcs2_state" },
  { name: "highPowerCurrent", value: "highpowercurrent" },
  { name: "SERVICE", value: "service" },
  { name: "MotorTemperature", value: "motortemperature" },
  { name: "motorpower", value: "motorpower" },
  { name: "highPowerVoltage", value: "highpowervoltage" },
  { name: "Press_Brake", value: "press_brake" },
  { name: "regenTorqueAvailable", value: "regentorqueavailable" },
  { name: "TractionCoolantLow", value: "tractioncoolantlow" },
  { name: "timeSpentInBatterytemperature_20_30_40", value: "timespentinbatterytemperature_20_30_40" },
  { name: "timeSpentInBatterytemperature_40_50_60", value: "timespentinbatterytemperature_40_50_60" },
  { name: "percentageTimeSpentInMotorspeed_neg_800_0_1000", value: "percentagetimespentinmotorspeed_neg_800_0_1000" },
  { name: "percentageTimeSpentInMotorspeed_1000_2000_3000", value: "percentagetimespentinmotorspeed_1000_2000_3000" },
  { name: "percentageTimeSpentInMotorspeed_3000_4000_4000+", value: "percentagetimespentinmotorspeed_3000_4000_4000plus" },
  { name: "EVerror", value: "everror" }
];

const yAxisValues = [
  { name: "Select Y Parameter", value: "" },
  { name: "percentageTimeSpentInAcc_pedal_position_1_0_10_20", value: "percentagetimespentinacc_pedal_position_1_0_10_20" },
  { name: "percentageTimeSpentInAcc_pedal_position_1_20_30_40", value: "percentagetimespentinacc_pedal_position_1_20_30_40" },
  { name: "percentageTimeSpentInAcc_pedal_position_1_40_50_60", value: "percentagetimespentinacc_pedal_position_1_40_50_60" },
  { name: "percentageTimeSpentInAcc_pedal_position_1_60_70_80", value: "percentagetimespentinacc_pedal_position_1_60_70_80" },
  { name: "percentageTimeSpentInAcc_pedal_position_1_80_90_100", value: "percentagetimespentinacc_pedal_position_1_80_90_100" },
  { name: "timeSpentInRegenderating_0_1_2", value: "timespentinregenderating_0_1_2" },
  { name: "timeSpentInRegenderating_3_4", value: "timespentinregenderating_3_4" },
  { name: "timeSpentInRegenderating_5_6_6+", value: "timespentinregenderating_5_6_6plus" },
  { name: "tractionTorqueAvailable", value: "tractiontorqueavailable" },
  { name: "BCS1_State, BCS2_State", value: "bcs1_state_bcs2_state" },
  { name: "highPowerCurrent", value: "highpowercurrent" },
  { name: "SERVICE", value: "service" },
  { name: "MotorTemperature", value: "motortemperature" },
  { name: "motorpower", value: "motorpower" },
  { name: "highPowerVoltage", value: "highpowervoltage" },
  { name: "Press_Brake", value: "press_brake" },
  { name: "regenTorqueAvailable", value: "regentorqueavailable" },
  { name: "TractionCoolantLow", value: "tractioncoolantlow" },
  { name: "timeSpentInBatterytemperature_20_30_40", value: "timespentinbatterytemperature_20_30_40" },
  { name: "timeSpentInBatterytemperature_40_50_60", value: "timespentinbatterytemperature_40_50_60" },
  { name: "percentageTimeSpentInMotorspeed_neg_800_0_1000", value: "percentagetimespentinmotorspeed_neg_800_0_1000" },
  { name: "percentageTimeSpentInMotorspeed_1000_2000_3000", value: "percentagetimespentinmotorspeed_1000_2000_3000" },
  { name: "percentageTimeSpentInMotorspeed_3000_4000_4000+", value: "percentagetimespentinmotorspeed_3000_4000_4000plus" },
  { name: "EVerror", value: "everror" }
];

const MultivariateAnalysisChart = () => {
  const [chartType, setChartType] = useState('Heatmap');
  const [xParam, setXParam] = useState({ name: "Select X Parameter", value: "" });
  const [yParam, setYParam] = useState({ name: "Select Y Parameter", value: "" });
  const [data, setData] = useState([]);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const { GlobalData } = useMultivarientVehicleData();

  const chartRef = useRef(null);

  // API call
  useEffect(() => {
    if (xParam.value !== "" && yParam.value !== "") {
      const url = API_URL_MAIN + "multivarient/" + xParam.value + "_vs_" + yParam.value;

      fetchData(
        {
          url,
          body: {
            filterdata: { ...GlobalData }
          }
        },
        (res) => {
          if (!res.length) {
            setData([]);
            return;
          }
          const formatData = res.map(item => ({
            ...item,
            value: item.value > 0 ? Number(item?.value?.toFixed(2)) : 0
          }));
          setData(formatData);
        }
      );
    }
  }, [yParam.value, xParam.value, GlobalData, fetchData]);

  useEffect(() => {
    if (
      xParam.value !== "" &&
      yParam.value !== "" &&
      !isLoading &&
      data.length > 0 &&
      chartRef.current
    ) {
      setTimeout(() => {
        chartRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 150);
    }
  }, [xParam.value, yParam.value, isLoading, data.length, chartType]);

  return (
    <>
      {/* Controls */}
      <div ref={chartRef} id="apply-section" className={styles['controls-wrapper']}>
        <div className={styles['control-item']}>
          <label className='fw-bold'>Chart Type</label>
          <select
            className={`form-select ml-1 mb-2  ${styles.filter_dropdown}`}
            value={chartType}
            onChange={e => setChartType(e.target.value)}
          >
            <option value={"Heatmap"}>Heatmap</option>
            <option value={"BubbleChart"}>Bubble Chart</option>
          </select>
        </div>

        <div className={styles['control-item-axis']}>
          <label className='fw-bold'>X-Axis</label>
          <select
            className={`form-select  ${styles.filter_dropdown}`}
            value={xParam?.value || ""}
            onChange={e => {
              const selectedObj = xAxisValues.find(i => i.value === e.target.value);
              setXParam(selectedObj || { name: "Select X Parameter", value: "" });
            }}
          >
            {xAxisValues
              .filter(x => !yParam?.value || x.value !== yParam?.value)
              .map((item, idx) => (
                <option key={idx} value={item.value}>
                  {item.name}
                </option>
              ))}
          </select>
        </div>

        <div className={`${styles['control-item-axis']}`}>
          <label className='fw-bold'>Y-Axis</label>
          <select
            className={`form-select ${styles.filter_dropdown}`}
            value={yParam?.value || ""}
            onChange={e => {
              const selectedObj = yAxisValues.find(i => i.value === e.target.value);
              setYParam(selectedObj || { name: "Select Y Parameter", value: "" });
            }}
          >
            {yAxisValues
              .filter(y => !xParam?.value || y.value !== xParam?.value)
              .map((item, idx) => (
                <option key={idx} value={item.value}>
                  {item.name}
                </option>
              ))}
          </select>
        </div>
      </div>

      {/* Chart + messages */}
      <div style={{ minHeight: "500px" }}>
        {
          (xParam.value === "" || yParam.value === "") ? (
            <div className={`d-flex justify-content-center align-items-center height-400 ${styles["height-300"]}`} >
              Please Select Two Parameters
            </div>
          ) : isLoading ? (
            <div className='d-flex justify-content-center'>
              <ChartLoader position='' height={400} />
            </div>
          ) : !data.length ? (
            <div className={`d-flex justify-content-center align-items-center height-400 ${styles["height-300"]}`} >
              Data Is Not Available For Selected Parameters
            </div>
          ) : (
            <>
              {chartType === 'Heatmap' && (
                <Heatmap
                  data={data}
                  xAxisName={xParam.name}
                  yAxisName={yParam.name}
                />
              )}

              {chartType === 'BubbleChart' && (
                <ScatterChart
                  xAxisName={xParam.name}
                  yAxisName={yParam.name}
                  data={data}
                />
              )}
            </>
          )
        }
      </div>
    </>
  );
};

export default MultivariateAnalysisChart;
